import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { registerLocale } from "react-datepicker";
import {
    Col,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from "reactstrap";
import TextArea from "antd/es/input/TextArea";

export interface Props {
    data: any;
    onClose: any
}

registerLocale("en", en);
registerLocale("ko", ko);

const ModalDetail = ({ data, onClose }: Props) => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.title = `${t("Community AI (TBED) Detail")} - ${t("Content Management")} | OnnyJob`;
        document.body.classList.remove("vertical-sidebar-enable");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Modal isOpen={true} centered={true} scrollable={false} size="xl">
                <ModalHeader toggle={onClose}>
                    {t("Community AI (TBED) Detail")}
                </ModalHeader>
                <ModalBody className="py-3 px-4">
                    <div>
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3">
                                    <Label className="form-label">
                                        {t("Prompt")}{" "}
                                    </Label>

                                    <TextArea
                                        name={`prompt`}
                                        value={data?.prompt?.prompt}
                                        autoSize={{ minRows: 4, maxRows: 10 }}
                                        readOnly
                                    />
                                </div>
                            </Col>

                            <Col lg={12}>
                                <div className="mb-3">
                                    <Label className="form-label">
                                        {t("Response")}{" "}
                                    </Label>

                                    <TextArea
                                        name={`response`}
                                        value={data?.prompt?.response}
                                        autoSize={{ minRows: 4, maxRows: 10 }}
                                        readOnly
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default ModalDetail;
